/**
 * Get default options
 */
export function getDefaultOptions() {
  return {
    handler: null
  }
}

/**
 * Parse options
 * @param {Object} options options
 */
export function parseOptions(options = {}) {
  return Object.assign({}, getDefaultOptions(), options)
}
